import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { SetShiftSearchActions ,setTheShiftexcelSheetUpdatesAction } from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/Client/ConfirmationPopup.scss"
import dayjs from "dayjs";
import useDebouncedEffect from 'use-debounced-effect';
import { toast } from "react-toastify";

const ConfirmationPopup = ({ selectedDate, onClose, currentPageShift = 1 }) => {
  const dispatch = useDispatch();
  const state = useSelector((state)=>state)
  const branchId = useSelector(
    (state) => state.ClientBranchIDs?.clientBranchEditView
  );

  const [selectedShift, setSelectedShift] = useState(null);
const [shiftOptions , setshiftOptions] = useState([]);
  const [isWeekOff, setIsWeekOff] = useState(false);
  const stateData = useSelector(
    (state) => state.ShifteexcelshettRetriev?.ShfiexcelRetrieve
  );
    const initialStateSearch = {
      shiftsearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);
  
    const initialDebouanceSearch = {
      shiftsearch: "",
    };
    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
  
    useDebouncedEffect(
      () => {
        if (setSearchDebounance) {
          setSearched({
            ...SearchedVal,
            shiftsearch: SearchDebounance.shiftsearch,
          });
  
        }
      },
      500,
      [SearchDebounance]
    );

  useEffect(() => {
    if (branchId) {
      const payloads = {
        search: SearchedVal?.shiftsearch,
        page_size: 20,
        page: 1,
        client_id: branchId,
      };
      dispatch(SetShiftSearchActions(payloads));
    }
  }, [state.ClientBranchIDs?.clientBranchEditView ,SearchedVal]);
console.log(state.ShiftSearch?.ShiftSearch ,"state.ShiftSearch?.ShiftSearch");

useEffect(()=>{
if(state.ShiftSearch?.ShiftSearch!= null && state.ShiftSearch?.ShiftSearch?.length > 0 && state.ShiftSearch?.ShiftSearch != undefined){
          let objectArray = [];
      state.ShiftSearch?.ShiftSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.shift_name,
        });
      });
setshiftOptions(objectArray)
}
else {
    setshiftOptions([])

}
},[])
useEffect(() => {
  if (!stateData || !selectedDate) return;

  // Extract day number from selected date
  const dateObj = dayjs(selectedDate);
  const dayNumber = dateObj.date(); // 1, 2, 3, ...
  const dayKey = `day_${dayNumber}`;

  // Fetch corresponding data from state
  const dayData = stateData[dayKey];

  console.log("🗓️ Selected Date:", selectedDate);
  console.log("🔑 Day Key:", dayKey);
  console.log("📦 Day Data:", dayData);

  if (!dayData) {
    // No data for that day
    setSelectedShift(null);
    setIsWeekOff(false);
    return;
  }

  // If the value is a string → weekoff or no record
  if (typeof dayData === "string") {
    if (dayData.toLowerCase() === "weekoff") {
      setIsWeekOff(true);
      setSelectedShift(null);
    } else {
      setIsWeekOff(false);
      setSelectedShift(null);
    }
  }

  
  // If it's an object → it's a valid shift
  else if (typeof dayData === "object") {
    setSelectedShift({
      value: dayData.id,
      label: dayData.shift_name,
    });
    setIsWeekOff(false);
  }
    console.log(dayData ,"dayData");

}, [selectedDate, stateData]);


const HandletheShifts = (selected) => {
     setSelectedShift(selected)
}
  const handleWeekOffChange = (e) => {
    const checked = e.target.checked;
    setIsWeekOff(checked);

    if (checked) {
      setSelectedShift(null); // Clear shift when week off is selected
    }
  };
 const handleInputChange = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    shiftsearch: Val,

  });
};


  const handleSave = () => {
    const date = dayjs(selectedDate);
    const dayKey = `day_${date.date()}`; // e.g. day_11

  // ✅ Validation: Require either Week Off or a Shift
  if (!isWeekOff && !selectedShift) {
    toast.error("Please select a shift or mark the day as Week Off before saving")
    return; // stop execution
  }

    let payload = {
      date: date.format("YYYY-MM-DD"),
      day: date.date(),
      month: date.month() + 1,
      year: date.year(),
      user_id: stateData?.user_id?.id || "",
      client_id: stateData?.client_id?.id || "",
        [dayKey]: isWeekOff
    ? "weekoff"
    : selectedShift?.id || selectedShift?.value || null, // ✅ computed key

    };

    // Add the dynamic day key
    //   
    const passing_changes= {
EditId:stateData?.id,
        data:payload,

    }
 console.log("✅ Final Payload to Save:", payload ,passing_changes);

    dispatch(setTheShiftexcelSheetUpdatesAction(passing_changes,onClose()))
  };

  
  return (
    <div className="shift-popup-overlay">
      <div className="shift-popup">
        <h3>Assign Shift for {selectedDate}</h3>
<>
<div className="d-flex justify-content-end align-items-center">
    <label className="m-0">
          <input
            type="checkbox"
            checked={isWeekOff}
            onChange={handleWeekOffChange}
          />{" "}
          Week Off
        </label>
      </div>
      
<div>
    <label>
        Shift
    </label>
            <Select
          options={shiftOptions}
          placeholder="Select shift..."
          isSearchable
          value={selectedShift}
          onChange={HandletheShifts}
          isDisabled={isWeekOff}
          onInputChange={handleInputChange}

        />

</div>
</>
        <div className="popup-actions">
                      <button onClick={onClose}>Cancel</button>

          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
